import { BankAccountType } from './../../../../common/types/application/bank-details';

export enum BankName {
  firstNationalBank = 'FIRST NATIONAL BANK',
  nedbank = 'NEDBANK',
  standardBank = 'STANDARD BANK',
  absaBank = 'ABSA BANK',
  capitecBank = 'CAPITEC BANK',
  investec = 'INVESTEC',
  discoveryBank = 'DISCOVERY BANK',
  SASFIN = 'SASFIN',
  africanBank = 'AFRICAN BANK',
  absaBankLimited = 'ABSA BANK LIMITED',
  sasfinBankLimited = 'SASFIN BANK LIMITED',
  investecBank = 'INVESTEC BANK',
  tymeBankLimited = 'TYME BANK LIMITED',
  grindrodBank = 'Grindrod Bank',
  bankZero = 'BANK ZERO',
  bidvestBank = 'BIDVEST BANK',
  bnpParibas = 'BNP PARIBAS',
  citiBank = 'CITIBANK',
  finBond = 'FINBOND MUTUAL BANK',
  finBondEPE = 'FINBOND EPE',
  groBank = 'GROBANK LTD',
  hbzBank = 'HBZ BANK',
  hsbcBank = 'HSBC BANK',
  habibBank = 'HABIB OVERSEAS BANK',
  ithala = 'ITHALA',
  jpMorgan = 'JP MORGAN CHASE',
  lesothoPostBank = 'LESOTHO POST BANK',
  olympusMobile = 'OLYMPUS MOBILE',
  peoplesBank = 'PEOPLES BANK LTD INC NBS',
  postBank = 'POSTBANK',
  saReserve = 'S.A. RESERVE BANK',
  societeGenerale = 'SOCIETE GENERALE',
  standardChartered = 'STANDARD CHARTERED BANK',
  stateBankIndia = 'STATE BANK OF INDIA',
  uBank = 'UBANK LIMITED',
  vbsMutualBank = 'VBS MUTUAL BANK',
}

export const BANK_ACCOUNT_HOLDER_TYPE = {
  PERSONAL: 'personal',
  BUSINESS: 'business',
};

export const DEFAULT_UNIVERSAL_BRANCH_CODE_NAME = 'Universal Bank Codes';

export type Bank = {
  label: string;
  salesforceValue: string;
  creditVettingValue: BankName;
  universalBranchCode: string;
  universalBranchName: string;
  allowUserToOverrideBranch?: boolean;
};

export const bankInfo = {
  bankList: [
    {
      label: 'First National Bank',
      salesforceValue: 'FIRST NATIONAL BANK',
      creditVettingValue: BankName.firstNationalBank,
      universalBranchCode: '254005',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'Nedbank',
      salesforceValue: 'NEDBANK',
      creditVettingValue: BankName.nedbank,
      universalBranchCode: '198765',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'Standard Bank',
      salesforceValue: 'STANDARD BANK',
      creditVettingValue: BankName.standardBank,
      universalBranchCode: '051001',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'ABSA Bank',
      salesforceValue: 'ABSA BANK',
      creditVettingValue: BankName.absaBank,
      universalBranchCode: '632005',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'Capitec Bank',
      salesforceValue: 'CAPITEC BANK',
      creditVettingValue: BankName.capitecBank,
      universalBranchCode: '470010',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'Investec',
      salesforceValue: 'INVESTEC',
      creditVettingValue: BankName.investec,
      universalBranchCode: '580105',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'Discovery Bank',
      salesforceValue: 'DISCOVERY BANK',
      creditVettingValue: BankName.discoveryBank,
      universalBranchCode: '679000',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'Sasfin',
      salesforceValue: 'SASFIN',
      creditVettingValue: BankName.SASFIN,
      universalBranchCode: '683000',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'African Bank',
      salesforceValue: 'AFRICAN BANK',
      creditVettingValue: BankName.africanBank,
      universalBranchCode: '430000',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'ABSA Bank Limited',
      salesforceValue: 'ABSA BANK LIMITED',
      creditVettingValue: BankName.absaBankLimited,
      universalBranchCode: '632005',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'SASFIN Bank Limited',
      salesforceValue: 'SASFIN BANK LIMITED',
      creditVettingValue: BankName.sasfinBankLimited,
      universalBranchCode: '683000',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'Investec Bank',
      salesforceValue: 'INVESTEC BANK',
      creditVettingValue: BankName.investecBank,
      universalBranchCode: '580105',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'Tyme Bank Limited',
      salesforceValue: 'TYME BANK LIMITED',
      creditVettingValue: BankName.tymeBankLimited,
      universalBranchCode: '678910',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'Grindrod Bank',
      salesforceValue: 'GRINDROD BANK',
      creditVettingValue: BankName.grindrodBank,
      universalBranchCode: '584000',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'Bank Zero',
      salesforceValue: 'BANK ZERO',
      creditVettingValue: BankName.bankZero,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'Bidvest Bank',
      salesforceValue: 'BIDVEST BANK',
      creditVettingValue: BankName.bidvestBank,
      universalBranchCode: '462005',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'BNP Paribas',
      salesforceValue: 'BNP PARIBAS',
      creditVettingValue: BankName.bnpParibas,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'CitiBank',
      salesforceValue: 'CITIBANK',
      creditVettingValue: BankName.citiBank,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'FinBond Mutual Bank',
      salesforceValue: 'FINBOND MUTUAL BANK',
      creditVettingValue: BankName.finBond,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'FinBond EPE',
      salesforceValue: 'FINBOND EPE',
      creditVettingValue: BankName.finBondEPE,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'GROBANK LTD',
      salesforceValue: 'GROBANK LTD',
      creditVettingValue: BankName.groBank,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'HBZ Bank',
      salesforceValue: 'HBZ BANK',
      creditVettingValue: BankName.hbzBank,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'HSBC Bank',
      salesforceValue: 'HSBC BANK',
      creditVettingValue: BankName.hsbcBank,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'Habib Overseas Bank',
      salesforceValue: 'HABIB OVERSEAS BANK',
      creditVettingValue: BankName.habibBank,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'Ithala',
      salesforceValue: 'ITHALA',
      creditVettingValue: BankName.ithala,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'JP Morgan Chase',
      salesforceValue: 'JP MORGAN CHASE',
      creditVettingValue: BankName.jpMorgan,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'Lesotho Post Bank',
      salesforceValue: 'LESOTHO POST BANK',
      creditVettingValue: BankName.lesothoPostBank,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'Olympus Mobile',
      salesforceValue: 'OLYMPUS MOBILE',
      creditVettingValue: BankName.olympusMobile,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'Peoples Bank Ltd Inc NBS',
      salesforceValue: 'PEOPLES BANK LTD INC NBS',
      creditVettingValue: BankName.peoplesBank,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'PostBank',
      salesforceValue: 'POSTBANK',
      creditVettingValue: BankName.postBank,
      universalBranchCode: '460005',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
    },
    {
      label: 'S.A. Reserve Bank',
      salesforceValue: 'S.A. RESERVE BANK',
      creditVettingValue: BankName.saReserve,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'Societe Generale',
      salesforceValue: 'SOCIETE GENERALE',
      creditVettingValue: BankName.societeGenerale,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'Standard Chartered Bank',
      salesforceValue: 'STANDARD CHARTERED BANK',
      creditVettingValue: BankName.standardChartered,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'State Bank of India',
      salesforceValue: 'STATE BANK OF INDIA',
      creditVettingValue: BankName.stateBankIndia,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'UBank Limited',
      salesforceValue: 'UBANK LIMITED',
      creditVettingValue: BankName.uBank,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
    {
      label: 'VBS Mutual Bank',
      salesforceValue: 'VBS MUTUAL BANK',
      creditVettingValue: BankName.vbsMutualBank,
      universalBranchCode: '0',
      universalBranchName: DEFAULT_UNIVERSAL_BRANCH_CODE_NAME,
      allowUserToOverrideBranch: true,
    },
  ] as Bank[],
  debitOrderValues: [
    'First day of month',
    'Last day of the month',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
  ],
  accountTypes: [BankAccountType.CURRENT_CHEQUE, BankAccountType.SAVINGS],
  accountHolderType: {
    PERSONAL: BANK_ACCOUNT_HOLDER_TYPE.PERSONAL,
    BUSINESS: BANK_ACCOUNT_HOLDER_TYPE.BUSINESS,
  },
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
};
